import {
  Component,
  EventEmitter,
  HostListener,
  Output,
  inject,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  template: ``,
})
export class genericDialogComponent {
  readonly dialogRef = inject(MatDialogRef<genericDialogComponent>);

  constructor(public dialogref: MatDialogRef<genericDialogComponent>) {}

  closeDialog() {
    this.dialogRef.close(false);
  }

  @HostListener('window:keyup', ['$event'])
  updateField(event: KeyboardEvent): void {
    switch (event.key) {
      case 'ArrowUp':
        this.scrollUp();
        break;
      case 'ArrowDown':
        this.scrollDown();
        break;
      default:
        break;
    }
  }

  scrollUp(): void {
    window.scrollBy({
      top: -100, // scroll speed
      behavior: 'smooth',
    });
  }

  scrollDown(): void {
    window.scrollBy({
      top: 100, // scroll speed
      behavior: 'smooth',
    });
  }
}
export interface dialogData<dataType> {
  data: dataType;
}
